import { TForm } from "@/types/trpc.types";
import { CreateFormMutationData, SaveFormResponse } from "./types";
import { FieldTypeName } from "./fields";

export function sortByParentChildRelationship(arr:any[]) {
    // Create a lookup table to easily find objects by id
    const lookup:any = {};
    arr.forEach((item:any) => {
      lookup[item.id] = item;
    });
  
    // Create a new sorted array
    const sortedArray:any = [];
  
    // Helper function to recursively add items and their children
    function addItemAndChildren(item:any) {
      sortedArray.push(item);
  
      // Find children of the current item
      arr.forEach((child:any) => {
        if (child.parent === item.id) {
          addItemAndChildren(child); // Add child and its children
        }
      });
    }
  
    // Start with root elements (those with parent: null)
    arr.forEach((item:any) => {
      if (item.parent === null) {
        addItemAndChildren(item);
      }
    });
  
    return sortedArray;
}

export const formToSaveFormResponse = (form:TForm):SaveFormResponse => {
  return {
    id: form?.id || '',
    name: form?.name || '',
    description: form?.description || '',
    form: {
      fields: form?.fields?.map((field)=>({
        id: field.id,
        type: field.type as FieldTypeName,
        name: field.name ?? '',
        question: field.question ?? undefined,
        required: ('required' in field && typeof field.required === 'boolean') ? field.required : false,
        parent: field.parent_id,
        options: ('options' in field ? (field.options?.map((option) => ({
          id: option?.id,
          text: option?.text ?? '',
        }))) : [])
      })) || [],
      fieldResponses: []
    }
  }
}

export const saveFormResponseToUpdateForm = (form:SaveFormResponse) => {
  return {
    form_id: form?.id,
    name: form?.name || '',
    description: form?.description,
    fields: form?.form?.fields?.map((field, index)=>({
      field_id: field.id,
      type: field.type,
      name: field.name,
      question: field.question,
      parent_id: form?.form?.fields[index-1] ? (form?.form?.fields[index-1].id) : undefined,
      required: field.required,
      
      options: field.options?.map((option)=>({
        option_id: option.id,
        text: option.text
      }))
    }))
  }
}

type CreateFormOptions = {
  template?: boolean;
  folder_id?: string;
}

export const saveFormResponseToCreateForm = (form:SaveFormResponse, options:CreateFormOptions):CreateFormMutationData => {
  const fields = form?.form?.fields || []
  return {
    name: form?.name,
    description: form?.description,
    template: options.template,
    folder_id: options.folder_id,
    fields: fields?.map((field, index) =>({
      type: field.type,
      name: field.name,
      question: field.question,
      parent_id: fields[index-1] ? (fields[index-1].id) : undefined,
      required: field.required,
      
      options: field.options?.map((option)=>({
        text: option.text
      }))
    }))
  }
}